var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-icon box-icon--effect details-controllers-margin"},[_c('i',{class:("d-flex bx bx-" + _vm.speechIcon + " " + _vm.colorClass),attrs:{"type":"solid"},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }